export const LICENSE_CONFIG = {
  apiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/verify-license',
  renewalApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-renewal-payment',
  packageStatusApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/package-status',
  requestPackagePaymentApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-package-payment',
  packagesApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/packages',
  requestPackageUpgradeApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-package-upgrade',
  apiKey: 'lic_live_906b80e015620d7e12b0abb966fd5535c1edbf26c7d30e14',
  domain: 'taiyebafreshfood.com',
  supportWhatsApp: '01516585709',
};